import { useEffect, useRef, useState } from "react";
import { Field, Form, Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";

import {
  Box,
  Button,
  Grid2,
  Typography
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import MilestonesWrapper from "../../shared/components/admin/MilestonesWrapper";
import SprintWrapper from "../../shared/components/admin/SprintWrapper";

import { FormikQuillField } from "../../shared/components/formfields/FormikQuillField";
import { TextFormField } from "../../shared/components/formfields/TextFormField";
import { AutoCompleteField } from "../../shared/components/formfields/AutoCompleteField";
import { DropzoneUploadLargFileField } from "../../shared/components/formfields/DropzoneUploadLargFileField";
import RadioButtonGroup from "../../shared/components/formfields/RadioButtonGroup";

import CustomDivider from "../../shared/utils/CustomDivider";

import { useGetLmsSubtopicDetailForEditing } from "../../assets/api/useAdminApi";
import { useLmsDropdownOptions } from "./option/LsmOption";

import { putUpdateLmsSubtopic } from "../../assets/nodeApi/putApi/putAdminApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToaster } from "../../shared/utils/ToasterProvider";
import { postAddLsmSubtopic } from "../../assets/nodeApi/postApi/postAdminApi";

const uploadOptions = [
  { label: "File Upload", value: "file" },
  { label: "URL", value: "url" },
];

const AddEditSubtopic = () => {
  const queryClient = useQueryClient()
  const { showToaster } = useToaster();
  const { subtopicId, topicId } = useParams();

  const formikRef = useRef();
  const [uploadMode, setUploadMode] = useState("file");

  const { lmsParagraLanguage } = useLmsDropdownOptions();

  const { data: subtopicDetail, isLoading } =
    useGetLmsSubtopicDetailForEditing(subtopicId);

  // ---------- INITIAL VALUES ----------
  const initialValues = {
    name: subtopicDetail?.subtopic?.name || "",
    description: subtopicDetail?.subtopic?.description || "",
    files: subtopicDetail?.subtopic?.files || [],
    paragraphs:
      subtopicDetail?.subtopic?.paragraphs?.length > 0
        ? subtopicDetail.subtopic.paragraphs
        : [
          {
            description: "",
            language: "",
          },
        ],
  };

  // ---------- VALIDATION SCHEMA ----------
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Subtopic name is required"),
    description: Yup.string().required("Description is required"),

    paragraphs: Yup.array().of(
      Yup.object().shape({
        description: Yup.string().required("Paragraph description required"),
        language: Yup.string().required("Language is required"),
      })
    ),
  });

  const mutationUpdateLMSSubtopic = useMutation({
    mutationFn: ({ formData, id }) => putUpdateLmsSubtopic(formData, id),
  });

  const mutationAddLmsSubtopic = useMutation({
    mutationFn: ({ formData, id }) => postAddLsmSubtopic(id, formData),
  });






  // const handleSubmit = (values, { resetForm }) => {
  //   const formData = new FormData();

  //   formData.append("name", values.name);
  //   formData.append("description", values.description);

  //   const filesArray = Array.isArray(values.files) ? values.files : [];

  //   // 🔥 EXACT REQUIREMENT: files:[binary]
  //   filesArray.forEach((item) => {
  //     if (item instanceof File) {
  //       formData.append("files", item);     // <---- IMPORTANT CHANGE
  //     } else if (item?.file instanceof File) {
  //       formData.append("files", item.file);  // <---- IMPORTANT CHANGE
  //     }
  //   });

  //   // If only URL present
  //   if (
  //     filesArray.length > 0 &&
  //     typeof filesArray[0] === "string"
  //   ) {
  //     formData.append("file_url", filesArray[0]);
  //   }

  //   // ---- Paragraph logic (unchanged & correct) ----
  //   const formattedParagraphs = values.paragraphs.map((p) => {
  //     const obj = {
  //       description: p.description,
  //       language: p.language,
  //     };

  //     if (p.id) {
  //       obj.id = p.id;
  //     }

  //     return obj;
  //   });

  //   formData.append("paragraphs", JSON.stringify(formattedParagraphs));



  // }


  // const handleSubmit = (values, { resetForm }) => {
  //   const formData = new FormData();

  //   let fileCounter = 1;
  //   const filesToUpload = [];

  //   const filesArray = Array.isArray(values.files) ? values.files : [];

  //   const tempFiles = [];
  //   const fileDescriptions = [];
  //   const existingFileIds = [];

  //   filesArray.forEach((item) => {
  //     // NEW UPLOADED FILE
  //     if (item instanceof File || item?.file instanceof File) {
  //       const actualFile = item instanceof File ? item : item.file;
  //       const tempRef = `temp://${fileCounter++}`;

  //       tempFiles.push(tempRef);
  //       fileDescriptions.push(actualFile.name);
  //       filesToUpload.push(actualFile);
  //     }

  //     // EXISTING FILE URL
  //     else if (typeof item === "string") {
  //       tempFiles.push(item);
  //       fileDescriptions.push("URL");
  //     }

  //     // EXISTING FILE OBJECT WITH ID
  //     else if (item?.id) {
  //       tempFiles.push(item.url || "existing-url");
  //       fileDescriptions.push("URL");
  //       existingFileIds.push(item.id);
  //     }
  //   });

  //   // ---- paragraphs formatting ----
  //   const formattedParagraphs = values.paragraphs.map((p) => {
  //     const obj = {
  //       description: p.description,
  //       language: p.language,
  //     };

  //     if (p.id) {
  //       obj.id = p.id;
  //     }

  //     return obj;
  //   });

  //   // ---- BASE LEVEL FIELDS (COMMON FOR BOTH) ----
  //   formData.append("name", values.name);
  //   formData.append("description", values.description);
  //   // formData.append("files", JSON.stringify(tempFiles));
  //   formData.append("paragraphs", JSON.stringify(formattedParagraphs));

  //   // ---- ONLY FOR UPDATE CASE ----
  //   if (subtopicId) {
  //     formData.append(
  //       "file_descriptions",
  //       JSON.stringify(fileDescriptions)
  //     );

  //     const finalFileIds =
  //       existingFileIds.length > 0
  //         ? existingFileIds
  //         : values.file_ids || [subtopicDetail?.subtopic?.files[0]?.id];

  //     formData.append("file_ids", JSON.stringify(finalFileIds));
  //   }

  //   // ---- append actual binary files ----
  //   filesToUpload.forEach((file) => {
  //     formData.append("files", file);
  //   });

  //   // ---- API CALL ----
  //   if (subtopicId) {
  //     mutationUpdateLMSSubtopic.mutate(
  //       { formData, id: subtopicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Updated successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Update Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   } else {
  //     mutationAddLmsSubtopic.mutate(
  //       { formData, id: topicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Added successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Add Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   }
  // };


  // const handleSubmit = (values, { resetForm }) => {
  //   const formData = new FormData();

  //   formData.append("name", values.name);
  //   formData.append("description", values.description);

  //   const filesArray = Array.isArray(values.files) ? values.files : [];

  //   // ---------- ADD CASE (UNCHANGED) ----------
  //   if (!subtopicId) {
  //     filesArray.forEach((item) => {
  //       if (item instanceof File) {
  //         formData.append("files", item);
  //       } else if (item?.file instanceof File) {
  //         formData.append("files", item.file);
  //       }
  //     });
  //   }

  //   // ---------- UPDATE CASE – ONLY FIRST OBJECT ----------
  //   if (subtopicId) {
  //     const originalFiles = subtopicDetail?.subtopic?.files || [];

  //     const firstOriginal = originalFiles[0];
  //     const firstItem = filesArray[0];

  //     let finalFileObject = null;

  //     // 🔥 USER REPLACED FILE
  //     if (firstItem instanceof File || firstItem?.file instanceof File) {
  //       const actualFile =
  //         firstItem instanceof File ? firstItem : firstItem.file;

  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: actualFile,   // BINARY FILE
  //         description: actualFile.name,
  //       };
  //     }

  //     // 🔁 USER DID NOT CHANGE FILE
  //     else {
  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: firstOriginal?.file_path,
  //         description: firstOriginal?.description,
  //       };
  //     }

  //     // ---------- APPEND ONLY ONE OBJECT ----------
  //     formData.append("files[0].id", finalFileObject.id);

  //     if (finalFileObject.file_path instanceof File) {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     } else {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     }

  //     formData.append(
  //       "files[0].description",
  //       finalFileObject.description
  //     );
  //   }

  //   // ---------- PARAGRAPHS (SAME AS BEFORE) ----------
  //   const formattedParagraphs = values.paragraphs.map((p) => {
  //     const obj = {
  //       description: p.description,
  //       language: p.language,
  //     };

  //     if (p.id) {
  //       obj.id = p.id;
  //     }

  //     return obj;
  //   });

  //   formData.append("paragraphs", JSON.stringify(formattedParagraphs));

  //   // ---------- API CALL ----------
  //   if (subtopicId) {
  //     mutationUpdateLMSSubtopic.mutate(
  //       { formData, id: subtopicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Updated successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Update Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   } else {
  //     mutationAddLmsSubtopic.mutate(
  //       { formData, id: topicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Added successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Add Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   }
  // };



  //   const handleSubmit = (values, { resetForm }) => {
  //   const formData = new FormData();

  //   formData.append("name", values.name);
  //   formData.append("description", values.description);

  //   const filesArray = Array.isArray(values.files) ? values.files : [];

  //   // ---------- PARAGRAPHS ----------
  //   const formattedParagraphs = values.paragraphs.map((p) => {
  //     const obj = {
  //       description: p.description,
  //       language: p.language,
  //     };

  //     if (p.id) {
  //       obj.id = p.id;
  //     }

  //     return obj;
  //   });

  //   formData.append("paragraphs", JSON.stringify(formattedParagraphs));

  //   // ==========================
  //   // ADD CASE (NEW LOGIC)
  //   // ==========================
  //   if (!subtopicId) {
  //     const tempFiles = [];
  //     const uploads = [];

  //     let counter = 1;

  //     filesArray.forEach((item) => {
  //       if (item instanceof File || item?.file instanceof File) {
  //         const actualFile = item instanceof File ? item : item.file;

  //         const tempRef = `temp://${counter++}`;

  //         tempFiles.push(tempRef);
  //         uploads.push(actualFile);
  //       }
  //     });

  //     // 👉 REQUIRED BY BACKEND
  //     formData.append("files", JSON.stringify(tempFiles));

  //     // 👉 REQUIRED BY BACKEND
  //     uploads.forEach((file) => {
  //       formData.append("uploads", file);
  //     });
  //   }

  //   // ==========================
  //   // UPDATE CASE (UNCHANGED)
  //   // ==========================
  //   if (subtopicId) {
  //     const originalFiles = subtopicDetail?.subtopic?.files || [];

  //     const firstOriginal = originalFiles[0];
  //     const firstItem = filesArray[0];

  //     let finalFileObject = null;

  //     if (firstItem instanceof File || firstItem?.file instanceof File) {
  //       const actualFile =
  //         firstItem instanceof File ? firstItem : firstItem.file;

  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: actualFile,
  //         description: actualFile.name,
  //       };
  //     } else {
  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: firstOriginal?.file_path,
  //         description: firstOriginal?.description,
  //       };
  //     }

  //     formData.append("files[0].id", finalFileObject.id);

  //     if (finalFileObject.file_path instanceof File) {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     } else {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     }

  //     formData.append(
  //       "files[0].description",
  //       finalFileObject.description
  //     );
  //   }

  //   // ---------- API CALL ----------
  //   if (subtopicId) {
  //     mutationUpdateLMSSubtopic.mutate(
  //       { formData, id: subtopicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Updated successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Update Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   } else {
  //     mutationAddLmsSubtopic.mutate(
  //       { formData, id: topicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Added successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Add Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   }
  // };


  // const handleSubmit = (values, { resetForm }) => {
  //   const formData = new FormData();

  //   formData.append("name", values.name);
  //   formData.append("description", values.description);

  //   const filesArray = Array.isArray(values.files) ? values.files : [];

  //   // ---------- PARAGRAPHS (SAME AS BEFORE) ----------
  //   const formattedParagraphs = values.paragraphs.map((p) => {
  //     const obj = {
  //       description: p.description,
  //       language: p.language,
  //     };

  //     if (p.id) {
  //       obj.id = p.id;
  //     }

  //     return obj;
  //   });

  //   formData.append("paragraphs", JSON.stringify(formattedParagraphs));

  //   // ==========================
  //   // ADD CASE
  //   // ==========================
  //   if (!subtopicId) {

  //     // -------- URL MODE --------
  //     if (uploadMode === "url") {

  //       const enteredUrl = filesArray[0];

  //       if (enteredUrl && typeof enteredUrl === "string") {
  //         formData.append("files", JSON.stringify([enteredUrl]));
  //       } else {
  //         formData.append("files", JSON.stringify([]));
  //       }

  //       // 👉 IMPORTANT:
  //       // DO NOT append "uploads" field at all in URL mode
  //     }

  //     // -------- FILE UPLOAD MODE --------
  //     else if (uploadMode === "file") {

  //       const tempFiles = [];
  //       const uploads = [];

  //       let counter = 1;

  //       filesArray.forEach((item) => {
  //         if (item instanceof File || item?.file instanceof File) {
  //           const actualFile = item instanceof File ? item : item.file;

  //           const tempRef = `temp://${counter++}`;

  //           tempFiles.push(tempRef);
  //           uploads.push(actualFile);
  //         }
  //       });

  //       // 👉 REQUIRED BY BACKEND
  //       formData.append("files", JSON.stringify(tempFiles));

  //       // 👉 REQUIRED BY BACKEND
  //       uploads.forEach((file) => {
  //         formData.append("uploads", file);
  //       });
  //     }
  //   }

  //   // ==========================
  //   // UPDATE CASE (UNCHANGED)
  //   // ==========================
  //   if (subtopicId) {
  //     const originalFiles = subtopicDetail?.subtopic?.files || [];

  //     const firstOriginal = originalFiles[0];
  //     const firstItem = filesArray[0];

  //     let finalFileObject = null;

  //     if (firstItem instanceof File || firstItem?.file instanceof File) {
  //       const actualFile =
  //         firstItem instanceof File ? firstItem : firstItem.file;

  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: actualFile,
  //         description: actualFile.name,
  //       };
  //     } else {
  //       finalFileObject = {
  //         id: firstOriginal?.id,
  //         file_path: firstOriginal?.file_path,
  //         description: firstOriginal?.description,
  //       };
  //     }

  //     formData.append("files[0].id", finalFileObject.id);

  //     if (finalFileObject.file_path instanceof File) {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     } else {
  //       formData.append("files[0].file_path", finalFileObject.file_path);
  //     }

  //     formData.append(
  //       "files[0].description",
  //       finalFileObject.description
  //     );
  //   }

  //   // ---------- API CALL ----------
  //   if (subtopicId) {
  //     mutationUpdateLMSSubtopic.mutate(
  //       { formData, id: subtopicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Updated successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Update Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   } else {
  //     mutationAddLmsSubtopic.mutate(
  //       { formData, id: topicId },
  //       {
  //         onSuccess: () => {
  //           showToaster("Subtopic Added successfully!", "", "success");
  //           resetForm();

  //           queryClient.invalidateQueries({
  //             queryKey: ["lms/subtopicforediting"],
  //           });
  //         },
  //         onError: (err) => {
  //           showToaster(
  //             err?.response?.data?.error || "Failed to Add Subtopic",
  //             "",
  //             "error"
  //           );
  //         },
  //       }
  //     );
  //   }
  // };




  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();

    formData.append("name", values.name);
    formData.append("description", values.description);

    const filesArray = Array.isArray(values.files) ? values.files : [];

    // ---------- PARAGRAPHS ----------
    const formattedParagraphs = values.paragraphs.map((p) => {
      const obj = {
        description: p.description,
        language: p.language,
      };

      if (p.id) {
        obj.id = p.id;
      }

      return obj;
    });

    formData.append("paragraphs", JSON.stringify(formattedParagraphs));

    // ===========================================
    // FILES + UPLOADS LOGIC (COMMON FOR ADD/UPDATE)
    // ===========================================

    const fileMetadata = [];
    const uploads = [];

    let tempCounter = 1;

    // ORIGINAL FILES FROM API (ONLY FOR UPDATE)
    const originalFiles = subtopicDetail?.subtopic?.files || [];

    filesArray.forEach((item, index) => {
      const original = originalFiles[index];

      // ---- NEW UPLOADED FILE ----
      if (item instanceof File || item?.file instanceof File) {
        const actualFile = item instanceof File ? item : item.file;

        const tempRef = `temp://${tempCounter++}`;

        if (original?.id) {
          fileMetadata.push({
            ...(original?.id ? { id: original.id } : {}),
            file_path: tempRef,
            description: actualFile.name,
          });
        } else {
          fileMetadata.push(tempRef);
        }
        uploads.push(actualFile);
      }

      // ---- USER ENTERED URL ----
      else if (typeof item === "string") {

        if (original?.id) {
          fileMetadata.push({
            ...(original?.id ? { id: original.id } : {}),
            file_path: item,
            description: "URL file",
          })
        } else {
          fileMetadata.push(item);
        }

       
      }

      // ---- EXISTING FILE OBJECT FROM API ----
      else if (item?.file_path) {
        fileMetadata.push({
          id: item.id,
          file_path: item.file_path,
          description: item.description,
        });
      }
    });

    // 👉 REQUIRED BY BACKEND
    formData.append("files", JSON.stringify(fileMetadata));

    // 👉 Append binaries ONLY if new uploads exist
    uploads.forEach((file) => {
      formData.append("uploads", file);
    });

    // ---------- API CALL ----------
    if (subtopicId) {
      mutationUpdateLMSSubtopic.mutate(
        { formData, id: subtopicId },
        {
          onSuccess: () => {
            showToaster("Subtopic Updated successfully!", "", "success");
            resetForm();

            queryClient.invalidateQueries({
              queryKey: ["lms/subtopicforediting"],
            });
          },
          onError: (err) => {
            showToaster(
              err?.response?.data?.error || "Failed to Update Subtopic",
              "",
              "error"
            );
          },
        }
      );
    } else {
      mutationAddLmsSubtopic.mutate(
        { formData, id: topicId },
        {
          onSuccess: () => {
            showToaster("Subtopic Added successfully!", "", "success");
            resetForm();

            queryClient.invalidateQueries({
              queryKey: ["lms/subtopicforediting"],
            });
          },
          onError: (err) => {
            showToaster(
              err?.response?.data?.error || "Failed to Add Subtopic",
              "",
              "error"
            );
          },
        }
      );
    }
  };


  useEffect(() => {
    if (subtopicDetail?.subtopic?.files?.length > 0) {
      const firstFile = subtopicDetail.subtopic.files[0];

      if (firstFile.file_type === "video") {
        setUploadMode("url");

        // ALSO SET FORM VALUE
        formikRef.current?.setFieldValue(
          "files",
          [firstFile.file_path]
        );
      } else {
        setUploadMode("file");

        // For file type keep existing object
        formikRef.current?.setFieldValue(
          "files",
          subtopicDetail.subtopic.files
        );
      }
    }
  }, [subtopicDetail]);





  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values }) => (
        <Form>
          <MilestonesWrapper
            headerText={`${subtopicId ? "Update" : "Add"} SubTopic `}
            sx={{ border: "1px solid #4169E1" }}
          >
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <Field
                  name="name"
                  component={TextFormField}
                  label="Subtopic Name"
                  isRequired={true}
                />
              </Grid2>

              <Grid2 size={12}>
                <Field
                  name="description"
                  component={TextFormField}
                  label="Description"
                  isRequired={true}
                  multiline
                  rows={3}
                />
              </Grid2>

              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="subtitle1" mb={1}>
                  Choose file type
                </Typography>

                <RadioButtonGroup
                  options={uploadOptions}
                  value={uploadMode}
                  onChange={(val) => {
                    setUploadMode(val);

                    formikRef.current.setFieldValue("files", []);
                  }}
                  row
                />
              </Box>

              {uploadMode === "file" && (
                <Field
                  name="files[0]"
                  component={DropzoneUploadLargFileField}
                  multiple
                  label="Upload File(s)"
                  fileDetail={values.files?.[0]}
                />
              )}

              {uploadMode === "url" && (
                <Field
                  name="files[0]"
                  component={TextFormField}
                  label="Enter URL"
                  placeholder="https://..."
                />
              )}
            </Grid2>

            <CustomDivider />

            {/* ---------- PARAGRAPHS ---------- */}
            <FieldArray name="paragraphs">
              {({ push, remove }) => (
                <>
                  {values.paragraphs?.map((paragraph, pIndex) => (
                    <SprintWrapper
                      key={pIndex}
                      headerText={`Paragraph ${pIndex + 1}`}
                      onDelete={() => remove(pIndex)}
                    >
                      <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                          <Field
                            name={`paragraphs[${pIndex}].description`}
                            component={FormikQuillField}
                            label="Paragraph"
                            isRequired={true}
                          />
                        </Grid2>

                        <Grid2 size={12}>
                          <Field
                            name={`paragraphs[${pIndex}].language`}
                            component={AutoCompleteField}
                            options={lmsParagraLanguage.options}
                            label="Language"
                            isRequired={true}
                          />
                        </Grid2>
                      </Grid2>
                    </SprintWrapper>
                  ))}

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={() =>
                        push({
                          description: "",
                          language: "",
                        })
                      }
                      variant="contained"
                    >
                      Add Paragraph
                    </Button>
                  </Box>
                </>
              )}
            </FieldArray>
          </MilestonesWrapper>

          <Box sx={{ display: "flex", mt: 2 }}>
            <Button type="submit" variant="contained">
              {
                subtopicId ? "Update Subtopic" : "Add Subtopic"
              }
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default AddEditSubtopic;
